import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';

export const WeaponBlowtorch: WeaponDefinition = {
  id: 'blowtorch',
  name: 'Blowtorch',
  icon: 'blwtorch.1.png',
  category: 'utility',
  maxAmmo: 5,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: true,
  allowRetreat: false,

  fire(_ctx: WeaponContext): WeaponResult {
    return {
      success: true,
      entities: [],
      message: 'Blowtorch activated',
      bonusWeapon: 'blowtorch_active',
    };
  },
};
